<template>
  <div class="container" style="padding-left: 0px;padding-right: 0px">
    <!--    <h1>請以正確的方式進行進入系統</h1>-->
<!--    {{mode}}-->
    <div class="row">
      <div class="col-md-12">
        <div class="btn-group menuBar" role="group" aria-label="">
          <button type="button" class="btn btn-secondary btn-menu" @click="loadData('')" >全部</button>
          <template v-if="datas !==null">
            <button type="button" class="btn btn-secondary btn-menu" :class="{active : couponTagActive===couponTag.sid}" v-for="(couponTag,index) in showCouponTagList" :key="index" @click="loadData(couponTag.sid)">
              {{couponTag.codeName}}
            </button>
          </template>
        </div>
      </div>
    </div>
    <div class="nodata" style="box-shadow: rgb(204, 204, 204) 0px 0px 3px 3px;padding: 20px;margin: 20px" v-if="mode==='my' && isEmpty">
      您還沒領優惠券喔!<br >
      <button class="btn btn-primary" id="toOfferList" @click="gotoList">來去領優惠券</button>
    </div>
    <template v-if="datas !==null">


    <div class="row" v-for="(coupon,index) in datas.data.couponList"  :key="index">
<!--      //My-->
      <div class="col-md-12">
        <div class="card" style=";">
          <div class="" v-if="mode==='list'">
            <a href="#" @click="gotoDetail(coupon.couponSID)">
              <img :src="coupon.couponDisplayUrl" class="card-img-top" alt="...">
            </a>
          </div>
          <div v-else>
<!--            在我的優惠券時，多顯示優惠券狀態-->
            <div :class="getStatusText(coupon)? 'image-container':''" >
              <a href="#" @click="gotoDetail(coupon.couponSID)">
                <img :src="coupon.couponDisplayUrl" class="card-img-top" alt="...">
                <div class="centered-text">{{ getStatusText(coupon) }}</div>
              </a>
            </div>
          </div>
          <div class="card-body">
            <h5 class="card-title">{{ coupon.title }}</h5>
            <div class="card-text" style="display: flex; justify-content: space-between;">
              <span >
                有效時間：<span style="color: rgb(232, 83, 37);">{{ coupon.expiredDate?.substr(0,10) }} {{ coupon.expireDate?.substr(0,10) }}</span>

              </span>
              <span v-if="coupon.isGetUnLimit !==undefined && !coupon.isGetUnLimit">
                剩餘組數：<span style="color: rgb(232, 83, 37);">{{ getWordingCount(coupon) }}</span>
              </span>
              <span v-else-if="coupon.isUseUnLimit !==undefined && !coupon.isUseUnLimit">
                限量兌換：<span style="color: rgb(232, 83, 37);">{{ coupon.useCouponLimit }}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="nodata" style="box-shadow: rgb(204, 204, 204) 0px 0px 3px 3px;padding: 20px;margin: 20px" v-if="mode==='my'">
      <a class="btn btn-primary" @click="queryUsedCoupon" href="#" style="z-index: 0">查詢已使用/逾期優惠券</a>
    </div>
<!--要讓頁面長一點，避開下面的 GotoPage的區塊，這樣 "查詢已使用/逾期優惠券" 按鈕才可以按-->
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
      <br>
    </template>


    <div class="row">
      <div class="fixed-bottom d-flex justify-content-end p-4" >
        <a href="#" @click="gotoPage()">
          <img :src="getImageUrl()" alt="Floating Image" style="">
        </a>
      </div>

    </div>



  </div>
</template>

<script>
import apiCoupon from "@/js/apiCoupon";
import {CKey, readFromStorage} from '../js/storage.js';

export default {
  data() {
    return {
      datas:null,
      couponTagActive:"",
      mode:"list", //list,my
      C:"",    //由App帶過來的Token,要經過Api的解密，可以得到 Sid等資訊
      isEmpty:false,
      showCouponTagList:[]
    }
  },
  components: {

  },
  methods: {
    getImageUrl(){
      if (this.mode==="list"){
        return "/img/my.png";
      }else{
        return "/img/list.png";
      }
    },
    gotoPage(){
      if (this.mode==="list") {
        this.mode="my";
      }else{
        this.mode="list";
      }
      this.loadData("");
    },
    gotoList(){
      this.mode="list";
      this.loadData("");
    },
    getStatusText(coupon){
      //QQ
      if (coupon.isUsed) {
        return  "已使用";
      }
      else if ((!coupon.isUseUnLimit && coupon.useCouponLimit <= coupon.useCouponCount) || new Date().getTime() > new Date(coupon.expiredDate).getTime()) {
        return  "已失效";
      }
      return "";
      // else if (!item.IsSeen) {
      //   var stateDIV = $('<div/>').addClass("status_icon").appendTo(imgblkDIV);
      //   stateDIV.append('<img src="../Images/Coupon/new.png" width="100%" height="auto">');
      //   return  "";
      // }
    },
    queryUsedCoupon(){
      //查出 已使用的Coupon，且附加在最後
      let that=this;

      this.loadData_MyCoupon(that,"N",true);
    },
    async loadData_MyCoupon(that, isUsed,appendList) {
      apiCoupon.api_getMyCoupons(this.C,isUsed).then((data)=>{
        that.datas=apiCoupon.handleStatus(data);

        if (appendList){
          if (that.datas.data.couponList){
            that.datas.data.couponList.push(...that.datas.data.userCouponList);  //在java api 是將list放在這裡
          }else{
            that.datas.data.couponList=that.datas.data.userCouponList; //在java api 是將list放在這裡
          }

        }else{
          that.datas.data.couponList=that.datas.data.userCouponList; //在java api 是將list放在這裡
        }

        if (that.datas.data.couponList.length>0){
          that.isEmpty=false;
        }else{
          this.isEmpty=true;
        }
      })
    },
    async loadData(couponTag) {
      this.couponTagActive=couponTag;
      let that=this;

      if (this.mode==="my"){
        //預設先查出 未使用的Coupon
        this.loadData_MyCoupon(that,"Y",false);
      }else{
        apiCoupon.api_getCouponList(this.C,couponTag).then((data)=>{
          that.datas=apiCoupon.handleStatus(data);
          that.datas.data.couponList=that.datas.data.pendingCouponList; //在java api 是將list放在這裡

          if (that.datas.data.couponList.length>0){
            that.isEmpty=false;
          }else{
            this.isEmpty=true;
          }
          //----------------處理CouponTag-----------------------
          if (that.datas.data.couponList.length>0) {
            //取得目前有使用到的Tag (去除重覆)
            const distinctCouponTags = that.datas.data.couponList.reduce((coupon, currentItem) => {
              if (!coupon.includes(currentItem.couponTag)) {
                coupon.push(currentItem.couponTag);
              }
              return coupon;
            }, []);

            //篩選couponTagList,只留下需要的Tag
            const filteredCouponTags = that.datas.data.couponTagList.filter(tagItem => distinctCouponTags.includes(tagItem.sid +""));
            that.showCouponTagList=filteredCouponTags;
          }

          //---------------------------------------

        })
      }
    },
    gotoDetail(sid){
      this.$router.push({ name: 'CouponDetail', query: { couponSID: sid ,mode:this.mode}})
    },
    getWordingCount(coupon){
      const count=coupon.getCouponLimit - coupon.getCouponCount;
      if ((count) <= 0){
        return "已額滿";
      }else{
        return count;
      }
    },
    getWordingCount2(coupon){
      const count=coupon.useCouponLimit - coupon.useCouponCount;
      return count;
    }
  },
  mounted() {
    this.C=readFromStorage(CKey);
    this.mode=this.$route.query.mode;
    if (!this.mode){
      this.mode="list";
    }


    this.loadData("");
  }
}
</script>
<style>
.image-container {
  position: relative;
  display: inline-block; /* or "block" if you want it to take the full width */
}

.image-container img {
  display: block;
  width: 100%; /* adjust as needed */
  height: auto; /* adjust as needed */
}

.image-container::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5); /* semi-transparent white */
}

.image-container .centered-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: black; /* adjust as needed */
  font-size: 24px; /* adjust as needed */
  text-align: center;

  border: 5px solid #FF6700;
  background: #fff;
  width:185px;
  line-height:55px;
  z-index: 2;
}
</style>
